import { render, staticRenderFns } from "./oldCombofund.vue?vue&type=template&id=2bc9749e"
import script from "./oldCombofund.vue?vue&type=script&lang=js"
export * from "./oldCombofund.vue?vue&type=script&lang=js"
import style0 from "./oldCombofund.vue?vue&type=style&index=0&id=2bc9749e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports